import { mockLoanData } from '@frontend/pricing-search';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAllRatesRowData } from '../../../common/Qualification/QualificationActions';
import { RootState } from '../../../common/reducers';
import Common from '../../../common/services/Common';
import { PATH_SCENARIO_SEARCH } from '../../../route/constants';
import { AppDispatch } from '../../../store';
import { SearchResult } from '../../SearchResult';
import ScenarioFooter from '../components/ScenarioFooter';

export const ScenarioResults: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const allRatesRowData = useSelector(
    (state: RootState) => state.EPPS?.allRatesRowData,
  );

  const footerProps = allRatesRowData
    ? {
        onCancel: () => dispatch(setAllRatesRowData(null)),
        cancelLabel: 'Back' as const,
      }
    : {
        onCancel: () => Common.closeApplication(),
      };

  return (
    <>
      <SearchResult defaultTab="Classic" asEmbedded navigateOnError={() => navigate(PATH_SCENARIO_SEARCH)} />
      <ScenarioFooter {...footerProps} />
    </>
  );
};

export default ScenarioResults;
